import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const MESES_ABREV = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function formatFechaCorta(fecha) {
  const [, m, d] = fecha.split('-').map(Number);
  return `${d} ${MESES_ABREV[m - 1]}`;
}

export default function PendientesProduccion({ onSeleccionar }) {
  const { empresaActiva } = useAuth();
  const [pendientes, setPendientes] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!empresaActiva) return;
    setCargando(true);
    api
      .get('/produccion/pendientes')
      .then(({ data }) => setPendientes(data))
      .finally(() => setCargando(false));
  }, [empresaActiva]);

  if (cargando) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm p-5">
      <div className="flex items-center gap-2 mb-1">
        {pendientes.length > 0 ? (
          <AlertTriangle size={16} className="text-amber-500 flex-shrink-0" />
        ) : (
          <CheckCircle2 size={16} className="text-teal-600 flex-shrink-0" />
        )}
        <p className="font-medium text-slate-600">
          {pendientes.length > 0
            ? `${pendientes.length} turno${pendientes.length === 1 ? '' : 's'} sin cargar · últimos 14 días`
            : 'Todo cargado · últimos 14 días'}
        </p>
      </div>

      {pendientes.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {pendientes.map((p) => (
            <button
              key={`${p.fecha}_${p.turno}`}
              type="button"
              onClick={() => onSeleccionar && onSeleccionar(p)}
              disabled={!onSeleccionar}
              className={`text-xs font-medium rounded-full px-3 py-1 border border-amber-200 bg-amber-50 text-amber-700
                ${onSeleccionar ? 'hover:bg-amber-100 cursor-pointer' : 'cursor-default'}`}
            >
              {formatFechaCorta(p.fecha)} · {p.turno === 'diurno' ? 'Diurno' : 'Nocturno'}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
